module.exports = __webpack_public_path__ + "9a545fe7acacdef28d645dc3f042e0cc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-1.png
// module id = 2654
// module chunks = 0